import { useEffect, useState } from "react";
import {
  Pencil,
  Trash,
  Eye,
  ChevronLeft,
  ChevronRight,
  ChevronFirst,
  ChevronLast,
} from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import {
  editStatusPropsect,
  getProspects,
  setNumProspectos,
  sortByStatus,
  sortNewIdea,
  sortProspects,
} from "../../../../slices/prospectSlice";
import phone from "../../../../assets/phone.svg";
import mail from "../../../../assets/mail.svg";
import { AnimatePresence } from "framer-motion";
import ModalViewProspect from "../../../../components/modales/prospect/ModalProspect";


import Filters from "../../../../components/Filters";
import Sorts from "../../../../components/Sorts";
import { message } from "antd";
import { motion } from "framer-motion";
import ModalDeleteProspect from "../../../../components/modales/prospect/ModalDelete";
import ModalEditProspect from "../../../../components/modales/prospect/ModalEditProspect";

export function ProspectsList() {
  const dispatch = useDispatch();
  const { prospects, numProspectos } = useSelector((state) => state.prospectos);
  const { isDarkMode } = useSelector((state) => state.darkMode);
  const [currentPage, setCurrenPage] = useState(1);
  const [order, setOrder] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [orderIdea, setOrderIdea] = useState(null);

  const startIndex = (currentPage - 1) * numProspectos;
  const endIndex = startIndex + numProspectos;
  const prospectsPaginates = prospects.slice(startIndex, endIndex);
  const totalPages = Math.ceil(prospects.length / numProspectos);

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrenPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrenPage(currentPage + 1);
    }
  };

  const handleChangeNumProspectos = (event) => {
    const newNumProspectos =
      event.target.value === "Todos"
        ? prospects.length
        : parseInt(event.target.value, 10);
    dispatch(setNumProspectos(newNumProspectos));
    setCurrenPage(1); // Reinicia la página a la primera cuando cambias el número de prospectos por página
  };

  useEffect(() => {
    // Inicializar el número de prospectos desde localStorage
    const savedNumProspectos = localStorage.getItem("numProspectos");
    if (savedNumProspectos) {
      dispatch(setNumProspectos(parseInt(savedNumProspectos, 10)));
    }
  }, [dispatch]);

  const [messageApi, contextHolder] = message.useMessage();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [selectedProspect, setSelectedProspect] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState(false);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Prospecto actualizado correctamente!",
    });
  };

  const errorMessage = () => {
    messageApi.open({
      type: "error",
      content: "Error al actualizar el prospecto",
    });
  };

  const successEditStatus = () => {
    messageApi.open({
      type: "success",
      content: "Status actualizado correctamente!",
    });
  };

  const errorEditStatus = () => {
    messageApi.open({
      type: "error",
      content: "Error al actualizar el status",
    });
  };

  const handleViewProspect = (prospect) => {
    setSelectedProspect(prospect);
    setIsModalOpen(true);
  };

  const handleViewProspectEdit = (prospect) => {
    setSelectedProspect(prospect);
    setIsModalEdit(true);
  };

  const handleViewDelete = (prospect) => {
    setSelectedProspect(prospect);
    setIsModalOpenDelete(true);
  };

  const handleEditStatus = async (id, status) => {
    try {
      await dispatch(editStatusPropsect({ id, status })).unwrap();

      dispatch(getProspects());

      setIsModalOpen(false);
      successEditStatus();
    } catch (error) {
      console.error(error);
      errorEditStatus();
    }
  };

  const handlerOrderClientName = () => {
    let newOrder = "";
    if (order === "") {
      newOrder = "asc";
    } else if (order === "asc") {
      newOrder = "desc";
    } else if (order === "desc") {
      newOrder = "";
    }
    setOrder(newOrder);
    dispatch(sortProspects(newOrder));
    setCurrenPage(1);
  };

  const handleStatus = () => {
    let newOrder = "";
    if (orderStatus === "") {
      newOrder = "asc";
    } else if (orderStatus === "asc") {
      newOrder = "desc";
    } else if (orderStatus === "desc") {
      newOrder = "";
    }
    setOrderStatus(newOrder);
    dispatch(sortByStatus(newOrder));
    setCurrenPage(1);
  };

  const handleSortNewIdea = () => {
    let newOrder = null;
    if (orderIdea === null) {
      newOrder = true;
    } else if (orderIdea === true) {
      newOrder = false;
    } else if (orderIdea === false) {
      newOrder = null;
    }
    setOrderIdea(newOrder);
    dispatch(sortNewIdea(newOrder));
    setCurrenPage(1);
  };

  useEffect(() => {
    dispatch(getProspects());
  }, [dispatch]);

  return (
    <div className="w-full min-h-screen bg-background font-poppina px-4 py-2 relative sm:p-6">
      {contextHolder}

      <div
        onClick={() => setSelectedFilters(!selectedFilters)}
        className="shadow bg-background border border-border w-[100px] h-[30px] sm:hidden block absolute top-1 right-5 "
      >
        <h1 className="text-center text-text  ">Filters</h1>
      </div>

      {selectedFilters && (
        <div className="">
          <AnimatePresence>
            <motion.div
              key="modal-background"
              onClick={() => setSelectedFilters(false)}
              className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2, ease: "easeOut" }}
            >
              <motion.div
                key="modal-content"
                onClick={(e) => e.stopPropagation()}
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2, ease: "easeOut" }}
                className="bg-background rounded-lg shadow-lg p-6 font-poppina w-[500px] mx-4 border border-gray-100"
              >
                <Filters setCurrenPage={setCurrenPage} />
              </motion.div>
            </motion.div>
          </AnimatePresence>
        </div>
      )}

      <div className="sm:flex hidden justify-center gap-2">
        <Filters setCurrenPage={setCurrenPage} />
      </div>

      <div className="max-w-7xl mx-auto bg-background sm:mt-0 mt-10 border border-border rounded-lg shadow-sm overflow-x-auto">
        <table className="w-full text-sm text-gray-700">
          <thead className="bg-background">
            <tr className="text-left">
              <th
                className="p-2 sm:p-4 cursor-pointer  items-center gap-1 text-subtitle "
                onClick={handlerOrderClientName}
              >
                Cliente
                <span className="text-sm ml-2">
                  {order === "asc" && "▲"}
                  {order === "desc" && "▼"}
                  {order === "" && "↕"}
                </span>
              </th>
              <th className="p-2 sm:p-4 hidden md:table-cell text-subtitle">
                Datos
              </th>
              <th
                className="p-2 sm:p-4 hidden md:table-cell cursor-pointer  text-subtitle"
                onClick={handleSortNewIdea}
              >
                Nuevo
                <span className="text-sm ml-2">
                  {orderIdea === true && "▲"}
                  {orderIdea === false && "▼"}
                  {orderIdea === null && "↕"}
                </span>
              </th>
              <th
                className="p-2 sm:p-4 cursor-pointer flex items-center gap-1 text-subtitle "
                onClick={handleStatus}
              >
                Status
                <span className="text-sm ml-2">
                  {orderStatus === "asc" && "▲"}
                  {orderStatus === "desc" && "▼"}
                  {orderStatus === "" && "↕"}
                </span>
              </th>
              <th className="p-2 sm:p-4 hidden lg:table-cell text-subtitle">
                Descripción
              </th>
              <th className="p-2 sm:p-4 text-center text-subtitle">Acciones</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {prospects && prospects.length > 0 ? (
              prospectsPaginates.map((prospect, index) => (
                <tr
                  key={prospect._id || index}
                  className={`transition-colors ${
                    isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
                  }`}
                >
                  <td
                    className="p-2 sm:p-4"
                    style={{
                      maxWidth: "120px",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    <p className="font-medium text-text">
                      {prospect.name || "Desconocido"}
                    </p>
                    <p className="text-xs text-gray-500">
                      {prospect.namePodcast || "Sin podcast"}
                    </p>
                  </td>

                  <td className="p-2 sm:p-4 hidden md:table-cell">
                    <div className="space-y-1">
                      <p className="text-xs sm:text-sm flex items-center text-text">
                        <img
                          src={phone}
                          alt="Teléfono"
                          className="w-4 h-4 mr-2"
                        />
                        +{prospect.phone}
                      </p>
                      <p className="text-xs sm:text-sm flex items-center text-text">
                        <img src={mail} alt="Email" className="w-4 h-4 mr-2" />
                        {prospect.email || "N/A"}
                      </p>
                    </div>
                  </td>

                  <td className="p-2 sm:p-4 hidden md:table-cell">
                    <span
                      className={`inline-block px-2 py-1 text-xs font-medium rounded ${
                        prospect.newIdea
                          ? "text-green-800 bg-green-100"
                          : "text-red-800 bg-red-100"
                      }`}
                    >
                      {prospect.newIdea ? "Sí" : "No"}
                    </span>
                  </td>

                  <td className="p-2 sm:p-4">
                    <span
                      className={`inline-block px-2 py-1 text-xs font-medium rounded ${
                        prospect.status === "Prospect"
                          ? "bg-yellow-100 text-yellow-800"
                          : prospect.status === "Approved"
                          ? "bg-green-100 text-green-800"
                          : prospect.status === "Rejected"
                          ? "bg-red-100 text-red-800"
                          : "bg-gray-100 text-gray-800"
                      }`}
                    >
                      {prospect.status}
                    </span>
                  </td>

                  <td className="p-2 sm:p-4 hidden lg:table-cell">
                    <p className="text-xs sm:text-sm text-text">
                      {prospect.description || "Sin descripción"}
                    </p>
                  </td>

                  <td className="p-2 sm:p-4">
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={() => handleViewProspect(prospect)}
                        className="p-1.5 sm:p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition"
                      >
                        <Eye className="w-4 h-4 sm:w-5 sm:h-5" />
                      </button>
                      <button
                        onClick={() => handleViewProspectEdit(prospect)}
                        className="p-1.5 sm:p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition"
                      >
                        <Pencil className="w-4 h-4 sm:w-5 sm:h-5" />
                      </button>
                      <button
                        onClick={() => handleViewDelete(prospect)}
                        className="p-1.5 sm:p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition"
                      >
                        <Trash className="w-4 h-4 sm:w-5 sm:h-5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="p-4 text-center text-gray-500">
                  No hay prospectos disponibles.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="flex justify-center items-center gap-4 mt-6">
        <select
          className="bg-background rounded text-text"
          onChange={handleChangeNumProspectos}
          value={numProspectos}
        >
          <option value={8}>8</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
          <option value={20}>20</option>
          <option value={25}>25</option>
          <option value={30}>30</option>
          <option value={prospects.length}>Todos</option>
        </select>

        <button
          onClick={() => setCurrenPage(1)}
          className={`flex items-center justify-center p-2 rounded-full bg-background border border-border transition-colors ${
            currentPage === 1 ? "cursor-not-allowed opacity-50" : ""
          }`}
          disabled={currentPage === 1}
        >
          <ChevronFirst className="w-5 h-5 text-text" />
        </button>

        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className={`flex items-center justify-center p-2 rounded-full bg-background border border-border transition-colors ${
            currentPage === 1 ? "cursor-not-allowed opacity-50" : ""
          }`}
        >
          <ChevronLeft className="w-5 h-5 text-text" />
        </button>
        <span className="text-sm text-text">
          Página {currentPage} de {totalPages}
        </span>
        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          className={`flex items-center justify-center p-2 rounded-full bg-background border border-border transition-colors ${
            currentPage === totalPages ? "cursor-not-allowed opacity-50" : ""
          }`}
        >
          <ChevronRight className="w-5 h-5 text-text" />
        </button>

        <button
          onClick={() => setCurrenPage(totalPages)}
          className={`flex items-center justify-center p-2 rounded-full bg-background border border-border transition-colors ${
            currentPage === totalPages ? "cursor-not-allowed opacity-50" : ""
          }`}
          disabled={currentPage === totalPages}
        >
          <ChevronLast className="w-5 h-5 text-text " />
        </button>
      </div>

      <AnimatePresence>
        <ModalViewProspect
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          setIsModalEdit={setIsModalEdit}
          prospect={selectedProspect}
          handleEditStatus={handleEditStatus}
        />
        <ModalDeleteProspect
          isModalOpenDelete={isModalOpenDelete}
          setIsModalOpenDelete={setIsModalOpenDelete}
          prospect={selectedProspect}
        />

        <ModalEditProspect
          isModalEdit={isModalEdit}
          setIsModalEdit={setIsModalEdit}
          prospect={selectedProspect}
          success={success}
          errorMessage={errorMessage}
        />
      </AnimatePresence>
    </div>
  );
}

export default ProspectsList;
